module.exports = __webpack_public_path__ + "img/plan_point_header.eb79539f.png";